<template>
  <div class="app-panel" :class="{'app-panel_flex': flex}">
    <div class="app-panel__header" v-if="$slots.header">
      <slot name="header"/>
    </div>
    <div class="app-panel__header" v-else-if="title.length || $slots.actions">
      <div class="app-panel__header-content">
        <div class="app-panel__header-texts">
          <div class="app-panel__title" v-html="title" />
          <div class="app-panel__subtitle" v-html="subtitle" v-if="subtitle"/>
        </div>


        <div class="app-panel__actions" v-if="$slots.actions">
          <slot name="actions"/>
        </div>
      </div>
    </div>

    <div class="app-panel__body" v-if="$slots.default">
      <slot />
    </div>

  </div>
</template>

<script>
  export default {
    name: "AppPanel",
    props: {
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      },
      flex: {
        default: false,
        type: Boolean
      }
    }
  }
</script>

<style lang="scss">
  .app-panel{
    background: #fff;
    /*box-shadow: 0 1px 6px 1px rgba(69,65,78,0.1);*/
    box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08);

    &__body{
      padding: 15px;
    }

    &__header{
      padding: 10px 15px 15px;
      border-bottom: 1px solid rgba(0,0,0,.125);
      min-height: 70px;

      &-content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-left: -10px;
        margin-top: -5px;
        min-height: 50px;
        padding: 5px 0 0;
      }
    }

    &__actions{
      margin-left: 10px;
      margin-top: 5px;

      .app-button + .app-button{
        margin-left: 5px;
      }
    }

    &__header-texts{
      margin-left: 10px;
      margin-top: 5px;
    }

    &__title{
      /*text-transform: uppercase;*/
      font-weight: 600;
      line-height: 1.1;
      /*font-size: 16px;*/
      font-size: 1.5rem;
      color: rgba(var(--app-text-dark), 1);
    }

    &__subtitle{
      font-weight: 600;
      line-height: 1.1;
      font-size: 1rem;
      color: rgba(var(--app-text-dark), 1);
      margin-top: 5px;
    }

    &_flex{
      display: flex;
      flex-flow: column nowrap;
      .app-panel{
        &__header{
          flex-shrink: 0;
        }
        &__body{
          flex: 1;
          min-height: 0;
        }
      }
    }


  }
</style>
